import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import GoogleSignInButton from '../GoogleSignInButton/GoogleSignInButton';
import './Register.css';

function Register() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { register, loginWithGoogle } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setError('Hesla se neshodují');
            return;
        }

        setLoading(true);
        try {
            await register(email, password);
            navigate('/');
        } catch (err) {
            setError(err.message || 'Registrace se nezdařila');
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleCredential = async ({ credential }) => {
        setError('');
        setLoading(true);
        try {
            await loginWithGoogle(credential);
            navigate('/');
        } catch (err) {
            setError(err.message || 'Registrace přes Google se nezdařila');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="register-page">
            <form className="register-form" onSubmit={handleSubmit}>
                <h2>Registrace</h2>
                {error && <div className="register-error">{error}</div>}
                <label htmlFor="email">Email</label>
                <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                />
                <label htmlFor="password">Heslo</label>
                <input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoComplete="new-password"
                />
                <label htmlFor="confirmPassword">Potvrdit heslo</label>
                <input
                    id="confirmPassword"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    autoComplete="new-password"
                />
                <button type="submit" disabled={loading}>
                    {loading ? 'Registruji...' : 'Zaregistrovat se'}
                </button>
                <div className="auth-divider"><span>nebo</span></div>
                <GoogleSignInButton onCredential={handleGoogleCredential} />
                <p className="register-link">
                    Již máte účet? <Link to="/login">Přihlásit se</Link>
                </p>
            </form>
        </div>
    );
}

export default Register;
